import { apiSlice } from '../../api';
import type {
  CreateApplicationTokenDTO,
  CreateApplicationTokenResult,
  DeleteApplicationTokenDTO,
  DeleteApplicationTokenResult,
  GetApplicationTokensDTO,
  GetApplicationTokensResult,
} from './types';

export const adminApplicationTokensEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getApplicationTokens: build.query<GetApplicationTokensResult, GetApplicationTokensDTO>({
        query: ({ application_uid }) => ({
          url: `/admin/v1/application/${application_uid}/application-tokens`,
          method: 'GET',
        }),
        providesTags: ['ApplicationTokens'],
      }),

      createApplicationToken: build.mutation<
        CreateApplicationTokenResult,
        CreateApplicationTokenDTO
      >({
        query: ({ application_uid, body }) => ({
          url: `/admin/v1/application/${application_uid}/application-tokens`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['ApplicationTokens'],
      }),

      deleteApplicationToken: build.mutation<
        DeleteApplicationTokenResult,
        DeleteApplicationTokenDTO
      >({
        query: ({ application_uid, application_token_uid }) => ({
          url: `/admin/v1/application/${application_uid}/application-tokens/${application_token_uid}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ApplicationTokens'],
      }),
    };
  },
});

export const { useGetApplicationTokensQuery } = adminApplicationTokensEndpoints;
export const { useCreateApplicationTokenMutation } = adminApplicationTokensEndpoints;
export const { useDeleteApplicationTokenMutation } = adminApplicationTokensEndpoints;

export type AdminApplicationTokensController = typeof adminApplicationTokensEndpoints;
